import SORT_ORDER from 'src/enums/sortOrder';
import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import { ColumnSorting } from '../BugsTable.config';
import { getBugs } from '../../../../api/bugs.api';
import { BugItem, BugsList, BugsFilters } from '../../../../types/Bugs';

export type BugsListState = FetchState<BugItem[]> & {
  total: number;
  page: number;
  offset: number;
  size: number;
};

type UseBugsListFetchParams = {
  siteCode: string;
  appName:string;
  filters: BugsFilters;
  sorting: ColumnSorting;
  page: number;
  pageSize: number;
};

const initialState: BugsListState = {
  loading: false,
  error: false,
  data: null,
  total: 0,
  page: 1,
  offset: 0,
  size: 0,
};

const useBugsListFetch = ({
  siteCode,
  appName,
  filters,
  sorting,
  page,
  pageSize,
}: UseBugsListFetchParams): [BugsListState, () => void] => {
  const params: BugsList.Request = {
    ...filters,
    siteCode,
    appName,
    size: pageSize,
    offset: page > 1 ? (page - 1) * pageSize + 1 : 1,
    sortingOrder: SORT_ORDER[sorting.order],
    sortingColumn: sorting.field,
  };

  //TODO fix dependencies
  const [{ loading, data, error }, refetch] = useFetchReducer(
    params.bugStatus ? () => getBugs(params) : null,
    Object.values(params)
  );
  const state: BugsListState = { ...initialState, loading, error };

  if (data === null) {
    return [state, refetch];
  }

  const { bugsList, totalRecords } = data;

  return [
    {
      ...state,
      data: bugsList,
      total: Number(totalRecords),
    },
    refetch,
  ];
};

export default useBugsListFetch;
